import { Box, IconButton } from "@mui/material";
import React from "react";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import LoginPage from "./LoginPage";
import RegisterPage from "./RegisterPage";

const ExtraPage = (propse) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          position: "fixed",
          backgroundColor: "#FFF",
          marginLeft: "100%",
          zIndex: "10",
          animation:
            propse.Width < 560
              ? propse.Extra === true
                ? "RTL 0.3s ease-in-out 0s 1 forwards"
                : propse.Extra === false
                ? "LTR 0.3s ease-in-out 0s 1 backwards"
                : null
              : null,
        }}
      >
        <Box
          sx={{
            width: "80%",
            height: "90%",
            marginLeft: "10%",
            marginTop: "5%",
          }}
        >
          <Box sx={{ width: "100%", height: "60px" }}>
            <IconButton
              sx={{ width: "40px", height: "40px", marginLeft: "-14px" }}
              onClick={() => propse.setExtra(false)}
            >
              <ArrowBackIosRoundedIcon
                sx={{ cursor: "pointer", color: "#707070" }}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "20px",
              fontFamily: "Aboreto",
              fontSize: "1rem",
              fontWieght: "bolder",
            }}
          >
            <Box
              sx={{
                width: "40px",
                height: "6px",
                backgroundColor: "#ed013e",
                marginBottom: "7px",
              }}
            ></Box>
            {propse.Login
              ? "Login"
              : propse.Register
              ? "Register"
              : propse.MoreInfo
              ? "More Info"
              : null}
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "80%",
              textAlign: "justify",
              fontFamily: "Poppins",
              fontSize: "0.75rem",
              marginTop: "20px",
              color: "rgba(0,0,0,0.7)",
              overflowY: propse.Login || propse.Register ? null : "auto",
            }}
          >
            {propse.Login ? (
              <LoginPage
                Width={propse.Width}
                Height={propse.Height}
                setShowModal={propse.setShowModal}
                Loading={propse.Loading}
                setLoading={propse.setLoading}
                setEmailRepeat={propse.setEmailRepeat}
                setisLogged={propse.setisLogged}
              />
            ) : propse.Register ? (
              <RegisterPage
                Width={propse.Width}
                Height={propse.Height}
                HTMLFor="R-E"
                setShowModal={propse.setShowModal}
                Loading={propse.Loading}
                setLoading={propse.setLoading}
                setEmailRepeat={propse.setEmailRepeat}
              />
            ) : propse.MoreInfo ? (
              <Box>
                The Leitner Box is a study aid or flashcard system used to help
                learners efficiently memorize information. It was developed by
                German psychologist Sebastian Leitner in the 1970s.
                <br /> <br />
                The Leitner Box consists of a set of index cards or flashcards,
                each with a question or piece of information on one side and the
                answer on the other. The cards are divided into several boxes,
                typically four or five, labeled with increasing levels of
                difficulty.
                <br /> <br />
                To use the Leitner Box system, learners start by reviewing the
                cards in the first box. If they answer a question correctly, the
                card is moved to the next box. If they answer incorrectly, the
                card is returned to the first box. Cards in the higher boxes are
                reviewed less frequently, as the assumption is that the learner
                has already memorized the information.
                <br /> <br />
                The Leitner Box system is based on the principle of spaced
                repetition, which is the idea that we are more likely to
                remember information if we review it at intervals spaced out
                over time, rather than trying to cram it all in at once. This
                makes it an effective study tool for learners of all ages and
                levels
              </Box>
            ) : null}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default ExtraPage;
